import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-action-corrective',
  templateUrl: './action-corrective.component.html',
  styleUrls: ['./action-corrective.component.css']
})
export class ActionCorrectiveComponent implements OnInit {

  @Input() public ActionCorrective: number;

  actionToDisplay: string;
  
  constructor() { }

  ngOnInit() {
    switch(this.ActionCorrective) {
      case 0:
        this.actionToDisplay = "Vide";
        break;
      case 25:
        this.actionToDisplay = "1/4";
        break;
      case 50:
        this.actionToDisplay = "1/2";
        break;
      case 75:
        this.actionToDisplay = "3/4";
        break;
      case 100:
        this.actionToDisplay = "Plein";
        break;
      default:
        break;
    }
  }

}
